export default __webpack_public_path__ + "static/media/892dab5c87ca38d9c16897aa20fd89201576698147947.1fbefda2.webp";